<div mat-dialog-content>
    <mat-card style="margin: 10px 0px">
        <mat-card-header class="r-checkout-confirm">
            <mat-card-title>Confirm Your Registration</mat-card-title>
        </mat-card-header>
        <mat-card-content class="r-checkout-confirm">
            <div style="border: solid thin; margin: 5px;padding:5px">
                <div class="container">
                    <div class="row">
                        <div class="col-4 r-output-label">
                            <span class="">Organisation </span>
                        </div>
                        <div class="col-8 r-output-value">
                            <span class=""> {{ data.invoicingData?.organisation}} </span>
                        </div>
                        <div class="col-4 r-output-label">
                            <span>VAT Number </span>
                        </div>
                        <div class="col-8 r-output-value">
                            <span [ngClass]="{ 'text-red': data.invoicingData?.vatNumber | isBlank }">
                                {{data.invoicingData?.vatNumber | blankOrNA}} </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 r-output-label">
                            <span class="">Contact name </span>
                        </div>
                        <div class="col-8 r-output-value">
                            <span class=""> {{data.invoicingData?.contactName}} </span>
                        </div>
                        <div class="col-4 r-output-label">
                            <span class="">Contact email </span>
                        </div>
                        <div class="col-8 r-output-value">
                            <span class=""> {{data.invoicingData?.contactEmail}} </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 r-output-label">
                            <span class="">Address </span>
                        </div>
                        <div class="col-8 r-output-value">
                            <span class=""> {{data.invoicingData?.address1}} </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="offset-sm-4 col-8 r-output-value">
                            <span class=""> {{data.invoicingData?.address2}} </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="offset-sm-4 col-8 r-output-value">
                            <span class=""> {{data.invoicingData?.zipCode}} {{data.invoicingData?.city}}</span>
                        </div>

                        <div class="offset-sm-4 col-4 r-output-value">
                            <span class=""> {{data.invoicingData?.country}} </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 r-output-label">
                            <span class=""> PO Number </span>
                        </div>
                        <div class="col-8 r-output-value">
                            <span [ngClass]="{ 'text-red': data.invoicingData?.poNumber | isBlank }">
                                {{data.invoicingData?.poNumber | blankOrNA}} </span>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer class="r-checkout-confirm">
            <p style="font-weight: bold">
                Registrants are fully responsible for ensuring the accuracy of the billing details provided during
                registration.</p>
            <p>If your organisation requires a purchase order for payment, it is your responsibility to provide it at
                the time of registration.</p>
            <p>CLEPA will not be held liable for any errors, delays, or issues resulting from
                incorrect or incomplete information on invoices or purchase orders. We strongly suggest that you
                carefully review and double-check all billing details before submitting your registration.</p>
            <p style="color: red">Please do NOT register multiple times. You will receive a confirmation from
                our team very soon.
            </p>
        </mat-card-footer>
        <mat-card-actions style="display: flex; justify-content: center;">
            <button mat-button mat-dialog-close style="margin-right: 10px;">No, go back</button>
            <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes, proceed</button>
        </mat-card-actions>
    </mat-card>



</div>